<template>
  <div :class="['soc-progress-bar-container', isDisabled ? 'disabled' : '']">
    <div
      class="soc-tool-tips"
      :style="{ left: tipValue - 26 + 'px' }"
      v-show="isTip"
      v-if="isShowTips"
    >
      <div class="soc-tool-tips-content">
        <em></em>
        <span>{{ formatValue }}</span>
      </div>
    </div>
    <div
      class="soc-progress-bar side"
      :id="'progressBar-' + sideId"
      @click="handleClickBar($event)"
    >
      <div
        class="soc-progress-progress side"
        :style="{ width: moveValue + 'px', background: activeColor }"
      ></div>
    </div>
    <div class="soc-progress-circle side" :style="{ left: moveValue + 'px' }">
      <div
        class="soc-progress-circle-content"
        :id="'soc-progress-circle-' + sideId"
        @mousedown="handleDragStart($event)"
        @mouseover="handleMouseOver($event)"
        @mouseleave="handleMouseLeave"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "soc-bar",
  model: {
    prop: "progressValue",
    event: "handleReturn",
  },
  props: {
    progressValue: {
      type: Number,
      default: 0,
    },
    fixed: {
      type: Number,
      default: () => 0,
    },
    formatTooltip: {
      type: Function,
      default: () => {
        return "";
      },
    },
    sideId: {
      type: String,
      default: () => "side",
    },
    activeColor: {
      type: String,
      default: () => "#407AEE",
    },
    isShowTips: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isDrag: false,
      mousemoveCall: null,
      mouseupCall: null,
      moveValue: 0,
      leftValue: 0,
      tipValue: 0,
      isTip: false,
      returnValue: 0,
      formatTip: "",
      result: 0,
    };
  },
  computed: {
    enableFormat() {
      return this.formatTooltip instanceof Function;
    },
    // 格式化提示框内容
    formatValue() {
      return this.enableFormat
        ? this.formatTooltip(this.returnValue)
        : this.returnValue;
    },
    getParentWidth() {
      return (
        document.querySelector("#progressBar-" + this.sideId).clientWidth - 18
      );
    },
  },
  watch: {
    progressValue: function (n, o) {
      if (n !== this.result) {
        this.upDateRenderView(n);
      }
    },
  },
  mounted() {
    if (this.progressValue) {
      this.upDateRenderView(this.progressValue);
    }
  },
  methods: {
    handleReturnValue() {
      this.returnValue = Number(
        Number((this.moveValue / this.getParentWidth) * 100).toFixed(this.fixed)
      );
    },
    // 拖动进度事件
    handleDragStart(e) {
      console.log(e);
      if (this.isDisabled) {
        return;
      }
      this.isDrag = true;
      this.isTip = true;
      let screenX = e.clientX;
      // 鼠标移动事件
      this.mousemoveCall = (e) => {
        let _move = this.leftValue + (e.clientX - screenX);
        if (_move <= 0) {
          this.moveValue = 0;
          this.tipValue = 0;
          this.handleReturnValue();
          return;
        }
        if (_move >= this.getParentWidth) {
          this.moveValue = this.getParentWidth;
          this.tipValue = this.getParentWidth;
          this.handleReturnValue();
          return;
        }
        this.moveValue = _move;
        this.tipValue = _move;
        this.handleReturnValue();
      };
      // 鼠标松开事件
      this.mouseupCall = (e) => {
        this.isDrag = false;
        document.removeEventListener("mousemove", this.mousemoveCall);
        this.mousemoveCall = null;
        document.removeEventListener("mouseup", this.mouseupCall);
        this.mouseupCall = null;
        this.leftValue = this.moveValue;
        this.isTip = false;
        this.handleReturn();
        this.$emit("change", this.result);
      };
      document.addEventListener("mousemove", this.mousemoveCall);
      document.addEventListener("mouseup", this.mouseupCall);
    },
    // 鼠标移入事件
    handleMouseOver(e) {
      if (this.isDisabled) {
        return;
      }
      if (e && !this.isDrag) {
        if (e.target.id === "soc-progress-circle-" + this.sideId) {
          let _left = document
            .querySelector("#soc-progress-circle-" + this.sideId)
            .parentElement.style.left.replace(/px/g, "");
          this.returnValue = Number(
            Number((Number(_left) / this.getParentWidth) * 100).toFixed(
              this.fixed
            )
          );
          this.tipValue = Number(_left);
        }
      }
      this.isTip = true;
    },
    // 鼠标移除事件
    handleMouseLeave() {
      if (this.isDisabled) {
        return;
      }
      if (this.isDrag) {
        return;
      }
      this.isTip = false;
    },
    // 进度条点击事件
    handleClickBar(e) {
      console.log(this.$parent, "===this.$parent.vStyle");
      if (this.isDisabled) {
        return;
      }
      let _left = Number(this.$parent.vStyle.left.replace(/px/g, ""));
      let _le = e.clientX - _left;
      this.moveValue = _le;
      this.leftValue = _le;
      this.handleReturnValue();
      this.handleReturn();
      this.$emit("change", this.result);
    },
    // model 回调函数
    handleReturn() {
      this.result = this.returnValue;
      this.$emit("handleReturn", this.result);
    },
    // 更新视图
    upDateRenderView(n) {
      let _v = this.getParentWidth * (n / 100);
      this.moveValue = _v;
      this.leftValue = _v;
      this.returnValue = n;
      this.result = n;
    },
  },
};
</script>

<style type="text/scss" lang="scss">
</style>
